import Vue from 'vue'
import Vuex from 'vuex'
import flexiapp from './modules/flexiapp' 
//import createLogger from '../../../src/plugins/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    flexiapp
  },
  strict: debug,
  //plugins: debug ? [createLogger()] : []
})